import { COL_TIMESHEET_ENTRIES } from '../config/collections'
import { pb } from '../pocketbase'
import type { TimesheetEntryRecord } from '../types/records'
import { timesheetEntryUpdatePatch } from './pbRecordDefaults'

export function workerIdFromEntry(entry: TimesheetEntryRecord): string {
  return typeof entry.worker === 'string' ? entry.worker : entry.expand?.worker?.id ?? ''
}

/** Записи табеля сотрудника за день на других сменах с явкой «на смене». */
export function otherPresentEntries(
  workerId: string,
  shiftId: string,
  allDayEntries: TimesheetEntryRecord[],
): TimesheetEntryRecord[] {
  return allDayEntries.filter((e) => {
    if (workerIdFromEntry(e) !== workerId) return false
    if (e.shift === shiftId) return false
    return e.present === true
  })
}

/** Снять явку на других сменах 2/2 за день (в этот день работает одна бригада). */
export async function clearOtherRotationShiftPresence(
  currentShiftId: string,
  rotationShiftIds: string[],
  allDayEntries: TimesheetEntryRecord[],
): Promise<void> {
  for (const e of allDayEntries) {
    if (!e.present) continue
    const sid = e.shift || ''
    if (!sid || sid === currentShiftId) continue
    if (!rotationShiftIds.includes(sid)) continue
    await pb.collection(COL_TIMESHEET_ENTRIES).update(
      e.id,
      timesheetEntryUpdatePatch(e, { present: false, hours: 0 }),
    )
  }
}

/** Снять явку на других сменах в этот день (один человек — одна смена). */
export async function clearOtherShiftPresence(
  workerId: string,
  shiftId: string,
  allDayEntries: TimesheetEntryRecord[],
): Promise<void> {
  const toClear = otherPresentEntries(workerId, shiftId, allDayEntries)
  for (const e of toClear) {
    await pb.collection(COL_TIMESHEET_ENTRIES).update(
      e.id,
      timesheetEntryUpdatePatch(e, { present: false, hours: 0 }),
    )
  }
}

export function isReplacementOnShift(
  worker: { defaultShift?: string | null },
  shiftId: string,
): boolean {
  const home = worker.defaultShift || ''
  return Boolean(home && home !== shiftId)
}
